import { useTipoUsuario } from "../../../../hooks/useTipoUsuario";
import { Breadcrumbs } from "../../../Home/Breadcrumb";
import { BuscarTipoUsuario } from "./Buscar";
import TableTipoUsuario from "./Table";



export const TipoUsuario = () => {

    const { guardado } = useTipoUsuario()
    return (
        <div className="content-page">
            <div className="content">
                <div className="container-fluid">
                    <Breadcrumbs
                        title={'Tipos de Usuario'}
                        nameFirst={'Seguridad'}
                        urlFirst={'/'}
                    />
                    {guardado &&
                        <div className="alert alert-success alert-dismissible fade show" role="alert">
                            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <strong>Actualización exitosa.</strong>
                        </div>
                    }
                    <BuscarTipoUsuario />
                    <TableTipoUsuario />

                </div>
            </div >
        </div >

    );
}
